import { gql } from "@apollo/client";

export const MARK_FILE_AS_VIEWED = gql`
  mutation markFileAsRead($id: String!) {
    markFileAsRead(id: $id)
  }
`;
